import { useEffect, useState } from 'react';
import { dayTimeFormat } from '../helpers';

export const useUTCDate = () => {
  const [utcDate, setUtcDate] = useState<Date>(new Date());

  useEffect(() => {
    const utcDateInterval = setInterval(() => {
      setUtcDate(new Date());
    }, 1000);
    return () => {
      clearInterval(utcDateInterval);
    };
  }, []);

  return dayTimeFormat(utcDate);
};
